import { Component, ElementRef, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { Location } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ErrorType } from 'src/app/enums/error-type.enum';

@Component({
  selector: 'fury-table-content-add',
  templateUrl: './table-content-add.component.html',
  styleUrls: ['./table-content-add.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class TableContentAddComponent implements OnInit {
  tableContentForm!: FormGroup;
  editorConfig = {
    allowedContent: false,
    toolbarGroups: [
      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
      { name: 'links' }, { name: 'insert' },
      { name: 'document', groups: ['mode', 'document', 'doctools'] },
      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
      { name: 'styles' },
      { name: 'colors' }
    ],
    forcePasteAsPlainText: true,
    image_previewText: ' '
  };
  constructor(
    private apiService: ApiService,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.formInit();
    this.getTableContent();
  }
  formInit(){
    this.tableContentForm = new FormGroup({
      headerText: new FormControl('', [Validators.required]),
      tableHeaderText: new FormControl('', [Validators.required]),
      rightSideTextArea: new FormControl('', [Validators.required]),
    })
  };

  getTableContent(){
    this.apiService.get('admin/settings/home-warranty-compare/get-home-warranty-compare-settings').subscribe((res: any)=>{
      if(res?.body){
        this.tableContentForm.patchValue(res?.body?.compareHomeWarrantyCompanies) ;
      }
    })
  }
  addContent(){ 
    if(this.tableContentForm.valid){
    this.apiService.post('admin/settings/home-warranty-compare/save-home-warranty-compare-settings', this.tableContentForm.value).subscribe((res: any)=>{
      if(res?.body){
        this.apiService.alert(res?.body?.message, ErrorType.Success);
        this.location.back();
      }
    }, err =>{
      if(err){
        this.apiService.alert(err?.message, ErrorType.Error);
      }
    })
      
    } else {
      this.tableContentForm.markAllAsTouched();
    }
  }

}
